/**
 * `crypto.randomUUID()` is missing on older WebViews — confirmed absent on Chrome 91, the
 * stock System WebView shipped by some Android 12 emulator images, even though the base Web
 * Crypto API (`crypto.getRandomValues`) has been supported for far longer. Falls back to
 * building a standard v4 UUID from that instead of throwing `TypeError: crypto.randomUUID is
 * not a function`.
 */
export function randomUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10

  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
